// iconUtils.js
import {
  FaFilePdf,
  FaFileImage,
  FaFileAudio,
  FaFileAlt,
  FaFile,
  FaFileWord,    
} from "react-icons/fa";

/**
 * Returns a corresponding icon component based on the MIME content type.
 * @param {string} type - MIME type string (e.g., "application/pdf", "image/jpeg").
 * @param {string} from - Optional label for logging/debugging.
 * @returns {JSX.Element} Icon representing the file type.
 */
export const getIconForContentType = (type, from) => {
  //console.info("Resolving icon for content type:", type, from);
  if (!type) return <FaFile className="me-2" />;

  const lower = type.toLowerCase();

  // --------------------------------------------------------------
  // PDF
  // --------------------------------------------------------------
  if (lower.includes("pdf"))
    return <FaFilePdf className="text-danger me-2" />;

  // --------------------------------------------------------------
  // WORD DOC / DOCX
  // --------------------------------------------------------------
  if (
    lower.includes("msword") ||                                   // application/msword
    lower.includes("officedocument.wordprocessingml.document") || // docx
    lower.endsWith(".doc") ||
    lower.endsWith(".docx") ||
    lower.includes("word")
  ) {
    return <FaFileWord className="text-primary me-2" />;
  }

  // --------------------------------------------------------------
  // Images
  // --------------------------------------------------------------
  if (lower.includes("image"))
    return <FaFileImage className="text-primary me-2" />;

  // --------------------------------------------------------------
  // Audio
  // --------------------------------------------------------------
  if (lower.includes("audio"))
    return <FaFileAudio className="text-success me-2" />;

  // --------------------------------------------------------------
  // Text
  // --------------------------------------------------------------
  if (lower.includes("text") || lower.includes("plain"))
    return <FaFileAlt className="text-muted me-2" />;

  // --------------------------------------------------------------
  // Default generic file
  // --------------------------------------------------------------
  return <FaFile className="me-2" />;
};
